export default __webpack_public_path__ + "static/media/mobileApple.87a2cfb8.svg";